import React, { useEffect, useState } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import axios from "axios";
import { BaseUrl } from "../../helper/apiHelper";
import { Icon } from "@iconify/react/dist/iconify.js";
import toast from "react-hot-toast";

const OrderOverview = () => {
  const [countryUsers, setCountryUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  // const [activeTab, setActiveTab] = useState("");
  const [activeTab, setActiveTab] = useState("REVIEW");

  const [isAddUser, setIsAddUser] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("");
  const statusOptions = [
    { label : "REVIEW", value : "REVIEW"},
    { label: "PLACED", value: "PLACED" },
    { label: "RECEIVED", value: "RECEIVED" },
    { label: "SHIPPED", value: "SHIPPED" },
    { label: "REACHED TO LOCAL PARTNER", value: "REACHED_TO_LOCAL_PARTNER" },
    { label: "DELIVERED", value: "DELIVERED" },
    { label: "HOLD", value: "HOLD" },
    { label: "CANCELLED", value: "CANCELLED" },
    { label: "REFUND", value: "REFUND" },
  ];
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [createLoading, setCreateLoading] = useState(false); // For create user button

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [loading, setLoading] = useState(false); // Add loading state
  const getCountryUsers = async () => {
    setLoading(true); // Start loading
    try {
      let body = { from, to, status: activeTab };
      let response = await axios.post(`${BaseUrl}/get-orders-master-admin`, body);
      if (response.status === 200) {
        setCountryUsers(response.data.data);
      }
    } catch (error) {
      
    } finally {
      setLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    setCurrentPage(1);
    getCountryUsers();
  }, [from, to, selectedCountry, activeTab]);
  
  // Effect for search functionality
  useEffect(() => {
    if (countryUsers.length > 0) {
      setFilteredUsers(countryUsers);
    }
  }, [countryUsers]);
  
  // Effect for filtering based on search term
  useEffect(() => {
    if (searchTerm.trim() === "") {
      setFilteredUsers(countryUsers);
    } else {
      const filtered = countryUsers.filter(
        (order) =>
          order.display_id?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
          order.invoice_id?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
          order.pickup_type?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          order.shipment_type?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          order.from?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          order.to?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredUsers(filtered);
    }
    setCurrentPage(1); // Reset to first page on search
  }, [searchTerm, countryUsers]);

  const paginatedUsers = filteredUsers.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  const handleCountryChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedCountry(selectedValue);

    const countryMap = {
      "CHINA-INDIA": { from: "CHINA", to: "INDIA" },
      "CHINA-CANADA": { from: "CHINA", to: "CANADA" },
      "INDIA-CANADA": { from: "INDIA", to: "CANADA" },
      "INDIA-USA": { from: "INDIA", to: "USA" },
    };

    if (selectedValue === "") {
      setFrom("");
      setTo("");
    } else if (countryMap[selectedValue]) {
      setFrom(countryMap[selectedValue].from);
      setTo(countryMap[selectedValue].to);
    }
  };

  const tabOptions = [
    { value: "", label: "Select Country" },
    { value: "CHINA-INDIA", label: "CHINA - INDIA" },
    { value: "CHINA-CANADA", label: "CHINA - CANADA" },
    { value: "INDIA-CANADA", label: "INDIA - CANADA" },
    { value: "INDIA-USA", label: "INDIA - USA" },
  ];

  const handleCreateNewUser = async () => {
    setCreateLoading(true); // Start loading
    try {
      if (!username) return toast.error("Username is required");
      if (!email) return toast.error("Email is required");

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        return toast.error("Enter a valid email address");
      }

      if (!password) return toast.error("Password is required");

      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{6,}$/;
      if (!passwordRegex.test(password)) {
        return toast.error(
          "Password must be at least 6 characters long and include 1 uppercase, 1 lowercase, 1 number, and 1 special character"
        );
      }

      if (!selectedCountry) {
        return toast.error("Select the country");
      }

      let body = { email, username, password, from, to, isActive: isActive };
      let response = await axios.post(`${BaseUrl}/create-admin`, body);
      if (response.status === 200) {
        toast.success(response.data.message);
        setIsAddUser(false);
        getCountryUsers();
      }
    } catch (error) {
      toast.error(error.response.data.message);
      
    }
    finally {
      setCreateLoading(false); // Stop loading
    }
  };

  return (
    <MasterLayout>
      <Breadcrumb title="Order Overview" />
      <div className="col-xxl-12 mb-16">
        <div className="card p-0 overflow-hidden position-relative radius-12 h-100">
          <div className="card-body px-14">
            <ul
              className="nav bordered-tab border border-top-0 border-start-0 border-end-0 d-inline-flex nav-pills mb-8 w-100"
              role="tablist"
            >
              {statusOptions.map((tab) => (
                <li className="nav-item" key={tab.value} role="presentation">
                  <button
                    className={`nav-link px-16 py-10 ${activeTab === tab.value ? "active" : ""
                      }`}
                    type="button"
                    role="tab"
                    onClick={() => setActiveTab(tab.value)}
                  >
                    {tab.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="col-lg-12">
        <div className="card">



          <div className="card-header d-flex justify-content-between align-items-center flex-wrap">
           <div className="search-container position-relative">
                <input
                  type="text"
                  className="form-control ps-4 pe-5"
                  placeholder="Search by order ID, invoice ID..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ minWidth: "300px" }}
                />
                <Icon 
                  icon="solar:magnifer-linear" 
                  className="position-absolute" 
                  style={{ right: "15px", top: "50%", transform: "translateY(-50%)", color: "#6c757d" }} 
                />
              </div>
            <div className="d-flex align-items-center gap-3">
             
              <div className="position-relative" style={{ minWidth: "180px" }}>
                {/* <Icon
                  icon="solar:alt-arrow-down-outline"
                  className="position-absolute"
                  style={{
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                    color: "#6c757d",
                    zIndex: 1,
                  }}
                /> */}
                <select
                  className="form-select form-select-sm pe-5 ps-3 rounded border"
                  value={selectedCountry}
                  onChange={handleCountryChange}
                >
                  {tabOptions.map((tab) => (
                    <option key={tab.value} value={tab.value}>
                      {tab.label}
                    </option>
                  ))}
                </select>
              </div>
              {/* <button
                className="btn btn-primary-600 radius-8 px-20 py-11"
                onClick={() => {
                  setIsAddUser(true);
                  setSelectedCountry("");
                }}
              >
                Create Admin
              </button> */}
            </div>
          </div>

          <div className="card-body">
            {loading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  minHeight: "calc(100vh - 300px)",
                  width: "100%",
                  background: "transparent",
                }}
              >
                <div
                  className="spinner-border"
                  role="status"
                  style={{
                    color: "#243E85",
                    width: "3rem",
                    height: "3rem",
                  }}
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : paginatedUsers.length === 0 ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  minHeight: "200px",
                  width: "100%",
                  fontSize: "1.2rem",
                  color: "#243E85",
                  fontWeight: 500,
                }}
              >
                No orders found.
              </div>
            ) : (
              <>
                <div className="table-responsive">
                  <table className="table basic-border-table mb-0">
                    <thead>
                      <tr>
                        <th>Order Id</th>
                        <th>Invoice Id</th>
                        <th>Order Type</th>

                        <th> Order Amount </th>
                        {/* <th>Insurance Charges</th> */}

                        <th>  Shipment Type </th>

               <th>Route (From → To)</th>


                        {/* <th>UserName</th>
                        <th>Email</th>
                        <th>Status</th>
                        {!selectedCountry && <th>Route (From → To)</th>} */}
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedUsers?.map((items, index) => (
                        <tr key={index}>
                          <td>#{items?.display_id}</td>
                          <td>{items?.invoice_id || "-"}</td>
                          <td>{items?.pickup_type || "-"}</td>


                          <td>${items?.subTotal.toFixed(2)}</td>


                          {/* <td>${items?.insuranceCharges.toFixed(2) || 0}</td> */}
                          <td>
                            <span
                              style={{ maxWidth: "180px", margin: "auto" }} className={`${items?.shipment_type === "AIR"
                                  ? "bg-success-focus text-success-main"
                                  : "bg-warning-focus text-warning-main"
                                } px-24 py-4 rounded-pill fw-medium text-sm d-flex align-items-center gap-2 justify-content-center`}
                            >
                              {items?.shipment_type === "AIR" ? (
                                <>
                                  <Icon
                                    icon="mdi:airplane"
                                    width="16"
                                    height="16"
                                  />
                                  Air
                                </>
                              ) : (
                                <>
                                  <Icon icon="mdi:ferry" width="16" height="16" />
                                  Ship
                                </>
                              )}
                            </span>
                          </td>



   <td>{items.from + " -To- " + items.to}</td>



                          {/* <td>{formatDate(items?.createdAt)}</td> */}

                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {filteredUsers.length > itemsPerPage && (
                  <div className="mt-4 d-flex justify-content-between align-items-center">
                    <span>
                      Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
                      {Math.min(currentPage * itemsPerPage, filteredUsers.length)} of{" "}
                      {filteredUsers.length} orders
                    </span>
                    <div className="d-flex gap-2">
                      <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                      >
                        Prev
                      </button>
                      <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() =>
                          setCurrentPage((prev) =>
                            prev < Math.ceil(filteredUsers.length / itemsPerPage)
                              ? prev + 1
                              : prev
                          )
                        }
                        disabled={currentPage === Math.ceil(filteredUsers.length / itemsPerPage)}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>

        {isAddUser && (
          <div
            className=""
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1050,
            }}
          >
            <div className="modal-dialog modal-lg modal-dialog modal-dialog-centered">
              <div className="modal-content radius-16 bg-base">
                <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
                  <h1 className="modal-title fs-5" id="exampleModalLabel">
                    Create New User
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setIsAddUser(false)}
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body p-24">
                  <form action="#">
                    <div className="row">
                      <div className="col-6 mb-20">
                        <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                          Username
                        </label>
                        <input
                          type="text"
                          className="form-control radius-8"
                          placeholder="Enter username"
                          value={username}
                          onChange={(e) => setUsername(e.target.value)}
                        />
                      </div>
                      <div className="col-6 mb-20">
                        <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                          Email
                        </label>
                        <input
                          type="text"
                          className="form-control radius-8"
                          placeholder="Enter email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                      <div className="col-6 mb-20">
                        <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                          Password
                        </label>
                        <input
                          type="text"
                          className="form-control radius-8"
                          placeholder="Enter password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </div>
                      <div className="col-6 mb-20">
                        <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                          Select Country
                        </label>
                        <div
                          className="position-relative"
                          style={{ minWidth: "180px" }}
                        >
                          <Icon
                            icon="solar:alt-arrow-down-outline"
                            className="position-absolute"
                            style={{
                              right: "12px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              pointerEvents: "none",
                              color: "#6c757d",
                              zIndex: 1,
                            }}
                          />

                          <select
                            className="custom-select-no-arrow form-select form-select-sm pe-5 ps-3 rounded border"
                            style={{
                              height: "40px",
                              display: "flex",
                              alignItems: "center",
                            }}
                            value={selectedCountry}
                            onChange={handleCountryChange}
                          >
                            {tabOptions.map((tab) => (
                              <option key={tab.value} value={tab.value}>
                                {tab.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-12 mb-20">
                        <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                          Status{" "}
                        </label>
                        <div className="d-flex align-items-center flex-wrap gap-28">
                          <div className="form-check checked-success d-flex align-items-center gap-2">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="label"
                              id="Personal"
                              value="true"
                              checked={isActive === true}
                              onChange={() => setIsActive(true)}
                            />
                            <label
                              className="form-check-label line-height-1 fw-medium text-secondary-light text-sm d-flex align-items-center gap-1"
                              htmlFor="Personal"
                            >
                              <span className="w-8-px h-8-px bg-success-600 rounded-circle" />
                              Active
                            </label>
                          </div>
                          <div className="form-check checked-danger d-flex align-items-center gap-2">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="label"
                              id="Holiday"
                              value="false"
                              checked={isActive === false}
                              onChange={() => setIsActive(false)}
                            />
                            <label
                              className="form-check-label line-height-1 fw-medium text-secondary-light text-sm d-flex align-items-center gap-1"
                              htmlFor="Holiday"
                            >
                              <span className="w-8-px h-8-px bg-danger-600 rounded-circle" />
                              Inactive
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex align-items-center justify-content-center gap-3 mt-24">
                        <button
                          type="button"
                          onClick={() => setIsAddUser(false)}
                          className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                        >
                          Cancel
                        </button>
                        {/* <button
                          type="button"
                          onClick={handleCreateNewUser}
                          className="btn btn-primary border border-primary-600 text-md px-48 py-12 radius-8"
                        >
                          Save
                        </button> */}
                        <button
                          type="button"
                          onClick={handleCreateNewUser}
                          className="btn btn-primary border border-primary-600 text-md px-48 py-12 radius-8"
                          disabled={createLoading}
                        >
                          {createLoading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                                style={{ verticalAlign: "middle", color: "#fff" }}
                              ></span>
                              Saving...
                            </>
                          ) : (
                            "Save"
                          )}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </MasterLayout>

  );
};

export default OrderOverview;
